var _defs, _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleActionsAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "multiple-actions-add_svg__Regular",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".multiple-actions-add_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "multiple-actions-add_svg__cls-1",
    cx: 17.25,
    cy: 17.25,
    r: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "multiple-actions-add_svg__cls-1",
    d: "M17.25 14.25v6M14.25 17.25h6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "multiple-actions-add_svg__cls-1",
    cx: 6,
    cy: 3.75,
    r: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "multiple-actions-add_svg__cls-1",
    d: "M10.555 10.888A5.251 5.251 0 00.75 13.5v2.25H3l.75 7.5h4.5l.323-3.233"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "multiple-actions-add_svg__cls-1",
    cx: 16.5,
    cy: 3.375,
    r: 2.625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "multiple-actions-add_svg__cls-1",
    d: "M20.4 9a4.5 4.5 0 00-7.285-.71"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iUmVndWxhciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDoxLjVweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm11bHRpcGxlLWFjdGlvbnMtYWRkPC90aXRsZT48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjE3LjI1IiBjeT0iMTcuMjUiIHI9IjYiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIxNy4yNSIgeTE9IjE0LjI1IiB4Mj0iMTcuMjUiIHkyPSIyMC4yNSIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjE0LjI1IiB5MT0iMTcuMjUiIHgyPSIyMC4yNSIgeTI9IjE3LjI1Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI2IiBjeT0iMy43NSIgcj0iMyIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEwLjU1NSwxMC44ODhBNS4yNTEsNS4yNTEsMCwwLDAsLjc1LDEzLjV2Mi4yNUgzbC43NSw3LjVoNC41bC4zMjMtMy4yMzMiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjE2LjUiIGN5PSIzLjM3NSIgcj0iMi42MjUiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMC40LDlhNC41LDQuNSwwLDAsMC03LjI4NS0uNzEiLz48L3N2Zz4=";
export { SvgMultipleActionsAdd as ReactComponent };